import React from 'react';
import { Loader2 } from 'lucide-react';

const LoadingModal = ({ message = 'Loading...' }) => {
  return (
    <div className="loading-modal-overlay">
      <div className="loading-modal-content">
        <Loader2 className="loading-spinner" size={48} />
        {message && <p className="loading-message">{message}</p>}
      </div>
    </div>
  );
};

export default LoadingModal;
